<template>
    <div class="mainWalltetPage scrrolMidTable incWrap">
        <alert-notification v-if="notification_msg != ''"/>
        <!-- <app-twofa :call_from="'wallets'" v-if="parseInt(get_user.profile.gAuthenticatorEnabled) == 0 && withdrawalOtp" class="withdrawalAllow"></app-twofa> -->
        <div v-show="!withdrawalOtp || !(Object.keys(withdrawalItem).length > 0) || parseInt(get_user.profile.gAuthenticatorEnabled) == 1">
            <div class="topFilter-bar whiteBar d-flex align-items-center justify-content-end mt-3">
                <!-- <div class="topFilter-bar d-flex align-items-center justify-content-end nav-tabs noBG border-0">
                   
                    <div class="form-group mb-0 pr-1 text-right" @click="searchByFunc('ALL')">
                        <div class="slectStar d-flex align-items-center">
                            <span class="nav-link" :class="(searchBy == 'ALL')?'active':''">All Markets</span>
                        </div>
                    </div>
                    <div class="form-group mb-0 pr-1 text-right" @click="searchByFunc('favorites')">
                        <div class="slectStar d-flex align-items-center">
                            <span class="nav-link d-flex align-items-center" :class="(searchBy == 'favorites')?'active':''">
                                <feather size="16px" class="mr-2" type="star"></feather>
                                <span>favorites</span>
                            </span>
                        </div>
                    </div>
                    <div class="form-group mb-0 pr-1 text-right" @click="searchByFunc('BTC')">
                        <div class="slectStar d-flex align-items-center">
                            <span class="nav-link" :class="(searchBy == 'BTC')?'active':''">BTC</span>
                        </div>
                    </div>
                    <div class="form-group mb-0 pr-1 text-right" @click="searchByFunc('ETH')">
                        <div class="slectStar d-flex align-items-center">
                            <span class="nav-link" :class="(searchBy == 'ETH')?'active':''">ETH</span>
                        </div>
                    </div>
                    <div class="form-group mb-0 pr-1 text-right" @click="searchByFunc('USD')">
                        <div class="slectStar d-flex align-items-center">
                            <span class="nav-link" :class="(searchBy == 'USD')?'active':''">USD</span>
                        </div>
                    </div>
                    <div class="form-group mb-0 pr-1 text-right" @click="searchByFunc('USDT')">
                        <div class="slectStar d-flex align-items-center">
                            <span class="nav-link" :class="(searchBy == 'USDT')?'active':''">USDT</span>
                        </div>
                    </div>
                </div> -->
                <div class="d-flex align-items-center justify-content-end rightTP flex-wrap w-100 mb-3">
					
					<!--<div class="not-verified yet" v-if="(parseInt(get_user.lead_type) == 1 && parseInt(get_user.verified_status) == 0)" >
						<p class="redbtn">Please wait while we are verifying your document(s) </p>
					</div>--->
                    <div class="form-group pr-4 text-right mb-0" >
                        <input type="checkbox" class="cap_checkbox" id="checkbox-1" v-model="hideZero" @change="page = '1'" />
                        <label for="checkbox-1" class="checkbox-click-target py-2"> <span class="checkbox-box"></span>Hide zero balance </label>
                    </div>
                    <div class="form-group intoIcon mb-0">
                        <input type="text" class="form-control" placeholder="Search here" v-model="searchCurrency" @keyup="page = '1'" />
                        <span class="icoIcon"><feather type="search"></feather> </span>
                    </div>
                </div>
            </div>
            <div class="mid_scroll_content mt-0">
                <loader v-show="pageLoader"></loader>
                <section class="depoist_fund hideBox p-3 border-0 max-1440">
                    

                    <div class="row justify-content-center">
                        <!-- {{withdrawalItem}} -->
                        <div class="col-12 mobPad">
                            <div class="dataTable up-dowload table-responsive scrollbar customscrollbar">
                                <table class="table table-striped table-bordered" width="100%">
                                    <thead>
                                        <tr>
                                            <th>Name </th>
                                            <th>available BAL</th>
                                            <th>action</th>
                                            <!-- <th>btc value</th>
    									<th>usd value</th>-->
                                        </tr>
                                    </thead>
                                    <tbody>{{getPage}}
                                        <tr v-for="(value,index) in marginList()" v-if="index >= (page - 1)*pageLimit && index < page*pageLimit">
                                            <td>
                                                <span class="d-flex showValue" :class="(fev_list.includes(value.symbol))?'show':''">
                                                    <!-- <feather type="star" @click="addRemoveFev(value.symbol)"></feather> -->
                                                    <span class="inTableIcon ml-0">
                                                        <img
                                                            :src="'../../../../static/website/images/crypto_logos/'+value.symbol.toLowerCase()+'.png'"
                                                            @error="handleImgErr($event)"
                                                            :alt="value.symbol"
                                                            v-if="isImage(value.symbol.toLowerCase())"
                                                        />
                                                        <span class="firstName" v-else>{{value.symbol.charAt(0)}}</span>
                                                    </span>
                                                    <span class="currency_name">{{value.currency_name}}</span>
                                                </span>
                                            </td>
                                            <td>{{formatfloat(value.amount) || 0}}</td>
                                            <td class="depositAllow withdrawalAllow">
                                                
												
												<a class="depositBtn disabled" href="#" data-bs-toggle="tooltip" data-bs-placement="top" title="Please wait while we are verifying your document(s)" v-if="(parseInt(get_user.lead_type) == 0 && parseInt(get_user.verified_status) == 0 && value.keyType == 'ERC20') || (parseInt(get_user.lead_type) == 1 && parseInt(get_user.verified_status) == 0)">Deposit</a>
												<a class="depositBtn" href="#" @click="deposit_currency = value.symbol.toLowerCase(); deposit_currency_name= value.currency_name " v-else>Deposit </a>
												
                                                <span v-if="parseInt(get_user.lead_type) == 0 ">
													<a class="withdrawlBtn disabled" href="#" data-bs-toggle="tooltip" data-bs-placement="top" :title="(value.amount > 0)? 'Please wait while we are verifying your document(s)' : 'No balances available'" @click.prevent="" v-if="(parseInt(get_user.verified_status) == 0 && value.keyType == 'ERC20') ">Withdraw</a>
													<a class="withdrawlBtn disabled" href="#" data-bs-toggle="tooltip" data-bs-placement="top" :title="(value.amount > 0)? 'Please wait while we are verifying your document(s)' : 'No balances available'" @click.prevent="" v-else-if="(parseInt(get_user.verified_status) == 0 && value.keyType != 'ERC20' && formatfloat(value.amount) == 0)  ">Withdraw</a>
													<a class="withdrawlBtn disabled" href="#" data-bs-toggle="tooltip" data-bs-placement="top" :title="(value.amount > 0)? 'Please wait while we are verifying your document(s)' : 'No balances available'" @click.prevent="" v-else-if="(parseInt(get_user.verified_status) == 1 && value.keyType == 'ERC20' && formatfloat(value.amount) == 0)">Withdraw</a>
													<a class="withdrawlBtn disabled" href="#" data-bs-toggle="tooltip" data-bs-placement="top" :title="(value.amount > 0)? 'Please wait while we are verifying your document(s)' : 'No balances available'" @click.prevent="" v-else-if="(parseInt(get_user.verified_status) == 1 && value.keyType != 'ERC20' && formatfloat(value.amount) == 0)  ">Withdraw</a>
													<a class="withdrawlBtn" href="#" :class="(pageLoader)?'disabled':''" @click.prevent="withdrawalItem = value;withdrawalOtp = false" v-else>Withdraw</a>
												</span>
												<span v-else>
													<a class="withdrawlBtn disabled" href="#" data-bs-toggle="tooltip" data-bs-placement="top" :title="(value.amount > 0)? 'Please wait while we are verifying your document(s)' : 'No balances available'" @click.prevent="" v-if="(parseInt(get_user.verified_status) == 0 || formatfloat(value.amount) == 0)">Withdraw</a>
													<a class="withdrawlBtn" href="#" :class="(pageLoader)?'disabled':''" @click.prevent="withdrawalItem = value;withdrawalOtp = false" v-else>Withdraw</a>
												</span>
                                            </td>
                                            <!-- <td>0.0001251</td>
    									<td>1.34215411</td> -->
                                        </tr>
                                    </tbody>
                                    <table-loader :pageloader_value="false" :type="'table'" :colspan="'3'" :listLength="marginList().length" v-if="marginList().length == 0"></table-loader>
                                </table>
                            </div>
                            <pagination :totalRecords="marginList().length" :limit="pageLimit" :pageNo="page"></pagination>
                        </div>
                    </div>
                </section>
                <!-- Modal -->
            </div>
            <!--Deposit POP-UP-->
            <app-deposit :getCurrency="deposit_currency"  :currencyName="deposit_currency_name" v-if="deposit_currency != ''"></app-deposit>

            <!--Withdraw POP-UP-->
            <!-- <keep-alive> -->
                <app-withdraw v-if="Object.keys(withdrawalItem).length > 0" :withdrawalItem="withdrawalItem"></app-withdraw>
            <!-- </keep-alive> -->
        </div>
    </div>
</template>
<script>
import { tradingMixins } from '@/plugins/trading'
import { depositWithdrawalMixins } from '@/plugins/depositWithdrawal'
import deposit from '../deposit-withdrawal/popup_deposit'
import withdraw from '../deposit-withdrawal/popup_withdraw'
import math from '../../../../static/website/js/math.js'
// import TwoFa from '../security/security'
export default {
    name: 'wallets',
	mixins: [tradingMixins,depositWithdrawalMixins],
    data() {
        return {
			pageLoader : false,
            notification_msg:'',
            notification_type:'',
			margin_list: {}, // currency with ammount available in account
			fev_list: [],
			Showfev:false,
			searchBy:'ALL',
			hideZero: false,
			searchCurrency:'',
			page : '1',
            pageLimit : '10',
			errImage: ['abc'],
			//deposit-module================
			currency_selected : '',
			get_method_id : '',
			raised_max_limit_msg : '',
			responseTransLimitData : {
				"1":{"MONTHLY":"25000","DAILY":"15000","PERTXN":"5000"},
				"2":{"MONTHLY":"25000","DAILY":"15000","PERTXN":"5000"},
				"3":{"MONTHLY":"25000","DAILY":"15000","PERTXN":"5000"},
				"4":{"MONTHLY":"25000","DAILY":"15000","PERTXN":"5000"},
				"5":{"MONTHLY":"25000","DAILY":"15000","PERTXN":"5000"},
				"6":{"MONTHLY":"25000","DAILY":"15000","PERTXN":"5000"},
				"7":{"MONTHLY":"25000","DAILY":"15000","PERTXN":"5000"},
				"8":{"MONTHLY":"25000","DAILY":"15000","PERTXN":"5000"},
				"11":{"MONTHLY":"25000","DAILY":"15000","PERTXN":"5000"}
			},
            deposit_currency: '',
            deposit_currency_name : '',
			title : 'No balances available',

			withdrawalItem:{},
			withdrawalOtp: false,

		}
    },
    /*watch:{
        withdrawalItem(val){
            console.log('withdrawalItem------->',val)
        }
    },*/
    components:{
        appDeposit: deposit,
        appWithdraw: withdraw,
        // appTwofa : TwoFa
    },
    computed:{
        getPage(){
            if( Math.ceil( this.marginList().length/parseInt(this.pageLimit) ) < parseInt(this.page) ){
                this.page = parseInt(this.page) - 1
            }
        }
    },
	methods:{
        formatfloat(num){
            if(num){
                num = parseFloat(num)
                try{
                    return math.format(num,  {notation: 'fixed'}) || '';
                }catch(e){
                    try{ return num.toFixed(8) }catch(e){ return ''}
                }
            }else{
                return 0
            }
        },
        closeWithdrawal(){
            this.withdrawalItem = {}
        },
		searchByFunc(val){
			if(val != this.searchBy){
				this.searchBy = val;
				this.page = '1'
				this.searchCurrency = ''
			}
		},
		addRemoveFev(currency){
			if(this.fev_list.includes(currency)){
				this.fev_list = this.fev_list.filter(item => item !== currency)
			}else{
				this.fev_list.push(currency)
			}
			this._addfavoriteCurrencyList({'globalParams' :{
				'currencies' : this.fev_list
			},'localParams' :{"parameter" : this } })
		},
		isImage(img){ 
			return (this.errImage.includes(img))?false:true
		},
		handleImgErr(val){
			var fullSrc = val.target.src.split(".")
			var src = fullSrc[fullSrc.length-2].split("/")
			var img = src[src.length - 1]
			if(!this.errImage.includes(img)){ 
				this.errImage.push(img)
			}
		},
		marginList(){
			let returnData = [],NotZero=[]
			for(var key in this.$env_var.walletCurrencyList){
				// parseInt(key) > this.page
				var data = this.$env_var.walletCurrencyList[key]
				for(var key in this.margin_list){
					if(this.margin_list[key].currency == data.symbol){
						data['amount'] = this.margin_list[key].amount
						if(data['amount'] > 0){
							NotZero.push(data)
						}
					}
				}
				returnData.push(data)
			}
			if(this.hideZero){
				if(this.searchCurrency != ''){
					var search = this.searchCurrency.toLowerCase()
					NotZero = NotZero.filter(val => val.symbol.toLowerCase().includes(search) || val.currency_name.toLowerCase().includes(search))
				}
				if(NotZero.length <= parseInt(this.pageLimit)*(parseInt(this.page)-1) ){
					this.page = parseInt(this.page) - 1
				}

				if(this.searchBy == 'ALL'){
					return NotZero
				}else if(this.searchBy == 'favorites'){
					return NotZero.filter(val => this.fev_list.includes(val.symbol) )
				}else{
					return NotZero.filter(val => val.symbol == this.searchBy )
				}
			}else{
				if(this.searchCurrency != ''){
					var search = this.searchCurrency.toLowerCase()
					returnData = returnData.filter(val => val.symbol.toLowerCase().includes(search) || val.currency_name.toLowerCase().includes(search))
				}
				if(returnData.length <= parseInt(this.pageLimit)*(parseInt(this.page)-1) ){
					this.page = parseInt(this.page) - 1
				}

				if(this.searchBy == 'ALL'){
					return returnData
				}else if(this.searchBy == 'favorites'){
					return returnData.filter(val => this.fev_list.includes(val.symbol) )
				}else{
					return returnData.filter(val => val.symbol == this.searchBy )
				}
			}
		},
		//deposit-module======================
        transactionLimitCurrency(getCurrency){
            // this.get_method_id   = this.$env_var.bankCurrencyList.hasOwnProperty(getCurrency) ? 1 : 11;
            //clean state variable
            // this.deposit_currency  = getCurrency
            // this.$refs.deposit_module.transactionLimitCurrency()
        }
		
	},
	created(){
		this.pageName('Wallets')
        var _that = this
        this._runTradingAccount({ 'globalParams' :{ },'localParams' :{"parameter" : this}})
		this._runGetMarginInfo({ 'globalParams' :{ }, 'localParams' :{"parameter" : this,'page':'wallet'} })
		//this._runGetWithdrawalMethods({'globalParams' :{},'localParams' :{"parameter" : this } })
		this._getfavoriteCurrencyList({'globalParams' :{},'localParams' :{"parameter" : this } })
        setTimeout(function(){
            if(_that.$route.query.currency){
                // console.log('query------->',_that.$route.query.currency)
                var currency = _that.$route.query.currency
                _that.deposit_currency = currency
                _that.$router.replace({query:''})
            }
        }, 1000);
	},
    mounted() {
        const _that = this
        /*$(document).on("click", function(event){
            if(!$(event.target).closest('.withdrawalAllow').length && !$(event.target).closest('.vue-notification-group').length){
                _that.closeWithdrawal()
            }
            
            if(!$(event.target).closest('.depositAllow').length && !$(event.target).closest('.vue-notification-group').length){
                _that.deposit_currency = ''
            }
        });*/
    }
}
</script>



// WEBPACK FOOTER //
// src/components/website/wallet/wallets040522.vue